import React from "react";
import { Badge } from "@opendate-app/setlist";
import { formatPrice } from "../../shared/teamCurrencyFormatting";

export default function registrationAmount(registration, currencyCode) {
  if (registration.payment_kind === "comp") return <Badge color="blue" size="sm" dot>Comp</Badge>;
  return registration.amount != null ? formatPrice(Number(registration.amount), currencyCode) : "—";
}
